/* 数据统计 */
function statistics (query) {
    /* @query:{object}，url的查询参数 */
    let statisticsUrl = "//appmgr-web.fcbox.com/app/appStatistic/visitLink",
        script = document.createElement("script"),
        src = "",
        uuid = localStorage.getItem("detectiveUUID");
    if(!uuid) {
        uuid = (new Date()).getTime().toString() + 
               Math.round(Math.random() * 1000).toString();
        localStorage.setItem("detectiveUUID", uuid);
    }
    if(query.channel) {
        if(query.channel == "code") {
            src = joinUrl(statisticsUrl, "channel", "code");   // 二维码 
        } else {
            src = joinUrl(statisticsUrl, "channel", "share")   // 分享
        }
    } else {
        src = joinUrl(statisticsUrl, "channel", "visit");    // 第一次进入
    }

    src = joinUrl(src, "uuid", uuid);
    script.src = src;
    document.body.appendChild(script);

    function joinUrl(basicUrl, key, value) {
        /* 
            根据参数构建URL
            @basicUrl: {String}, 基础url
            @key: {String}, 参数名
            @value: {String}, 参数值 
        */
       var result = "";
       if(basicUrl.indexOf("?") == -1) {
           result = basicUrl + "?" + key + "=" + value;
       } else {
           result = basicUrl + "&" + key + "=" + value;
       }
       return result;
    }
}

export default statistics;


// WEBPACK FOOTER //
// ./src/plugins/statistics.js